<template>
  <div class="base">
    <div @click="handleClick" style="cursor: pointer;">
      <span>
        不包含在价格内
        <svg-icon v-if="isClick" icon-class="dobuleArrowUp"></svg-icon>
        <svg-icon v-else icon-class="dobuleArrowDown"></svg-icon>
      </span>
      <span class="span-right">￥15.80</span>
    </div>
    <div v-if="isClick" style="padding-left: 30px; padding-right: 30px;">
      <div>
        <span>8月20日 星期四</span><span class="span-right">￥11.80</span>
      </div>
      <div>
        <span>8月21日 星期五</span><span class="span-right">￥4.80</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      isClick: false
    }
  },
  methods: {
    handleClick () {
      this.isClick = !this.isClick
    }
  }
}
</script>

<style lang="stylus" scoped>
.base {
  font-size: 14px;
  padding-top: 10px;
  line-height: 25px;
  font-weight: 500;
  color: #fff;
}

.span-right {
  float: right;
}
</style>



// WEBPACK FOOTER //
// src/pages/newPages/booking/components/FoldPanelNot.vue